module.exports = __webpack_public_path__ + "static/img/HUNDREDS_Niu-niu.85bbc1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/HUNDREDS_Niu-niu.jpg
// module id = BWXV
// module chunks = 0